import api from "@common/api/index.js";
import Cookie from "@/utils/cookie.js";
import Tree from "@/utils/tree.js";
import { TOKEN_KEY } from "@/config/index";
import { getMain, getRequest } from "@/utils/index.js";
const state = {
  info: {
    nickname: "",
    roleId: "",
  },
  token: "",
  menuList: [],
  menuData: [],
  routes: [],
  main: null,
  currentCompanyId: Cookie.getCookie('companyId'),
  companyId: null,
  menuGroup: [],
  permissions: [],
};
const mutations = {
  SET_USER(state, data) {
    state.info = data;
    state.token = data.token;
    Cookie.setToken(data.token);
    Cookie.setCookie(TOKEN_KEY + "_houseId", "");
  },
  SET_USER2(state, data) {
    state.info = data;
    //state.currentCompanyId = data.companyId;
  },
  SET_MENU_DATA(state, data) {
    state.menuData = data;
  },
  SET_MENU_LIST(state, data) {
    state.menuList = data;
  },
  SET_ROUTES(state, data) {
    state.routes = data;
  },
  SIGNOUT(state) {
    Cookie.removeToken();
    Cookie.removeCookie("companyId");
    state.info = {
      nickname: "",
      roleId: "",
    };
    state.routes = [];
    state.roleId = "";
    state.token = "";
    state.main = null;
  },
  SET_MAIN(state, data) {
    state.main = data;
  },
  changeValue(state, newVal) {
    state.password = newVal;
  },
  SET_CURRENTCOMPANYID(state, newVal) {
    state.currentCompanyId = newVal;
  },
  SET_menuGroup(state, data) {
    state.menuGroup = data;
  },
  SET_menuGroupItem(state, data) {
    state.menuGroup[data.index].list = data.list;
  },
  SET_PER(state, newVal) {
    state.permissions = JSON.parse(JSON.stringify(newVal));
  },
};
const actions = {
  setPassword(context, password) {
    context.commit("changeValue", password);
  },

  login(ctx, loginForm) {
    return new Promise((resolve, reject) => {
      const userName = loginForm.userName.replace(/^\s*|\s*$/g, "");
      api.user
        .login(userName, loginForm.password)
        .then((res) => {
          ctx.commit("SET_USER", res.data);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getUser(ctx) {
    return new Promise((resolve, reject) => {
      api.user
        .getUserInfo(0)
        .then((res) => {
          ctx.commit("SET_USER2", res.data);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getUserForPerson(ctx) {
    return new Promise((resolve, reject) => {
      api.user
        .getUserInfo(0)
        .then((res) => {
          ctx.commit("SET_USER2", res.data);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getRoutes(ctx) {
    return new Promise((resolve, reject) => {
      ctx.commit("SET_MAIN", {});
      ctx.commit("SET_ROUTES", []); //先清空路由
      const cookieCompanyId = Cookie.getCookie("companyId");
      api.menu
        .getMyMenu(cookieCompanyId, "energy")
        .then((res) => {
          //获取到url数据
          let data = res.data;
          if (res.data.length == 0 || res.data == null) {
            resolve({
              code: null,
              success: false,
              msg: "当前用户尚无菜单。请联系创建该用户的用户！",
              data: null,
            });
            return;
          }
          for (let index = 0; index < data.length; index++) {
            if (!data[index].pagePath) {
              data[index].pagePath = "";
            }
            if (!data[index].pageParam) {
              data[index].pageParam = "";
            }
            data[index].pagePath = data[index].pagePath + data[index].pageParam;
          }
          data.sort((a, b) => {
            return a.orderNum - b.orderNum;
          });
          ctx.commit("SET_MENU_LIST", data);

          //删除带http的
          let comData = [];
          for (let index = 0; index < data.length; index++) {
            let pagePath = data[index].pagePath;
            data[index].iframe = false;
            let comItem = {};
            comItem = JSON.parse(JSON.stringify(data[index]));
            let path = comItem.pagePath;
            let url = comItem.pagePath;
            let params = {};
            if (pagePath.indexOf("?") > -1) {
              params = getRequest(pagePath);
              pagePath = pagePath.split("?")[0];
              path = pagePath;
            }
            comItem.path = path;
            comItem.url = url;
            comItem.params = params;
            let keepAlive = true;
            if (path === "/analysis/video") {
              keepAlive = false;
            }
            comItem.meta = {
              keepAlive: keepAlive,
            };
            comItem.component = pagePath.length == 0 ? "none" : pagePath;
            if (comItem.iframe == false) {
              comData.push(comItem);
            }
          }

          comData = Tree.creatMenuJson(comData, 0);

          //找出有没有第一级是直接页面的
          for (let i = 0; i < comData.length; i++) {
            if (comData[i].children.length == 0) {
              let item = JSON.parse(JSON.stringify(comData[i]));
              comData[i].children = [item];
              comData[i].path = "";
              comData[i].classA = true;
              comData[i].component = "Layout";
            }
          }

          data = Tree.creatMenuJson(data, 0);
          data = data.sort((a, b) => {
            return a.orderNum - b.orderNum;
          });
          let main = getMain(data[0]);
          if (main.path == "") {
            main.path = "/main";
          }
          ctx.commit("SET_MENU_DATA", data);
          ctx.commit("SET_MAIN", main);
          ctx.commit("SET_ROUTES", comData);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getRoutesForPerson(ctx) {
    let data = [
      {
        iconResourceId: "",
        id: "10518001281253527",
        isSystemIcon: 0,
        name: "个人钱包",
        orderNum: 1,
        pageId: "66666",
        pageInstanceName: "",
        pageParam: "",
        parentId: "0",
        templateId: "10518000493387922",
        pagePath: "/wallet/personal/Index",
      },
      {
        iconResourceId: "",
        id: "10518001380483226",
        isSystemIcon: 0,
        name: "个人租户自动支付设置",
        orderNum: 1,
        pageId: "10500376977760471",
        pageInstanceName: "",
        pageParam: "",
        parentId: "0",
        templateId: "10518000493387922",
        pagePath: "/predict/autoPaymentForPreson",
      },
      {
        iconResourceId: "",
        id: "10518002675613856",
        isSystemIcon: 0,
        name: "总览",
        orderNum: 1,
        pageId: "0",
        pageInstanceName: null,
        pageParam: "",
        parentId: "0",
        templateId: "10518000493387922",
        pagePath: "",
      },
      {
        iconResourceId: "",
        id: "10518002717098147",
        isSystemIcon: 0,
        name: "个人租户总览",
        orderNum: 1,
        pageId: "10500376977760479",
        pageInstanceName: null,
        pageParam: "",
        parentId: "10518002675613856",
        templateId: "10518000493387922",
        pagePath: "/overview/tenant/person",
      },
      {
        iconResourceId: "",
        id: "10518002783232166",
        isSystemIcon: 0,
        name: "账单",
        orderNum: 1,
        pageId: "0",
        pageInstanceName: null,
        pageParam: "",
        parentId: "0",
        templateId: "10518000493387922",
        pagePath: "",
      },
      {
        iconResourceId: "",
        id: "10518002817573033",
        isSystemIcon: 0,
        name: "个人账单",
        orderNum: 1,
        pageId: "10500376977760485",
        pageInstanceName: null,
        pageParam: "",
        parentId: "10518002783232166",
        templateId: "10518000493387922",
        pagePath: "/property/billForPreson",
      },
      {
        iconResourceId: "",
        id: "10518003602702510",
        isSystemIcon: 0,
        name: "个人租户历史租凭合同",
        orderNum: 1,
        pageId: "10500376977760469",
        pageInstanceName: "",
        pageParam: "",
        parentId: "0",
        templateId: "10518000493387922",
        pagePath: "/v2.0/contract/Tenement",
      },
      {
        iconResourceId: "",
        id: "10532861544603665",
        isSystemIcon: 0,
        name: "告警管理",
        orderNum: 1,
        pageId: "10529075171278901",
        pageInstanceName: null,
        pageParam: "",
        parentId: "0",
        templateId: "10518000493387922",
        pagePath: "/alarm/alarmManagement/alarmForPersonalLessee",
      },
    ];
    return new Promise((resolve, reject) => {
      if (data.length == 0 || data == null) {
        resolve({
          code: null,
          success: false,
          msg: "当前用户尚无菜单。请联系创建该用户的用户！",
          data: null,
        });
        return;
      }
      for (let index = 0; index < data.length; index++) {
        if (!data[index].pagePath) {
          data[index].pagePath = "";
        }
        if (!data[index].pageParam) {
          data[index].pageParam = "";
        }
        data[index].pagePath = data[index].pagePath + data[index].pageParam;
      }
      data.sort((a, b) => {
        return a.orderNum - b.orderNum;
      });
      ctx.commit("SET_MENU_LIST", data);

      //删除带http的
      let comData = [];
      for (let index = 0; index < data.length; index++) {
        let pagePath = data[index].pagePath;
        data[index].iframe = false;
        let comItem = {};
        comItem = JSON.parse(JSON.stringify(data[index]));
        let path = comItem.pagePath;
        let url = comItem.pagePath;
        let params = {};
        if (pagePath.indexOf("?") > -1) {
          params = getRequest(pagePath);
          pagePath = pagePath.split("?")[0];
          path = pagePath;
        }
        comItem.path = path;
        comItem.url = url;
        comItem.params = params;
        let keepAlive = true;
        if (path === "/analysis/video") {
          keepAlive = false;
        }
        comItem.meta = {
          keepAlive: keepAlive,
        };
        comItem.component = pagePath.length == 0 ? "none" : pagePath;
        if (comItem.iframe == false) {
          comData.push(comItem);
        }
      }
      comData = Tree.creatMenuJson(comData, 0);

      //找出有没有第一级是直接页面的
      for (let i = 0; i < comData.length; i++) {
        if (comData[i].children.length == 0) {
          let item = JSON.parse(JSON.stringify(comData[i]));
          comData[i].children = [item];
          comData[i].path = "";
          comData[i].classA = true;
          comData[i].component = "Layout";
        }
      }

      data = Tree.creatMenuJson(data, 0);
      data = data.sort((a, b) => {
        return a.orderNum - b.orderNum;
      });
      let main = getMain(data[0]);
      if (main.path == "") {
        main.path = "/main";
      }
      ctx.commit("SET_MENU_DATA", data);
      ctx.commit("SET_MAIN", main);
      ctx.commit("SET_ROUTES", comData);
      resolve({
        success: true,
        data: data,
      });
    });
  },
  getRoutesForCompanyUser(ctx) {
    let data = [
      {
        iconResourceId: "",
        id: "10517999159058557",
        isSystemIcon: 0,
        name: "公司钱包",
        orderNum: 1,
        pageId: "66668",
        pageInstanceName: null,
        pageParam: "",
        parentId: "0",
        templateId: "10517999127617659",
        pagePath: "/wallet/company/Index",
      },
      {
        iconResourceId: "",
        id: "10517999312601219",
        isSystemIcon: 0,
        name: "公司租户自动支付设置",
        orderNum: 1,
        pageId: "10500376977760474",
        pageInstanceName: null,
        pageParam: "",
        parentId: "0",
        templateId: "10517999127617659",
        pagePath: "/predict/autoPaymentForCompany",
      },
      {
        iconResourceId: "",
        id: "10517999401132166",
        isSystemIcon: 0,
        name: "总览",
        orderNum: 1,
        pageId: "0",
        pageInstanceName: null,
        pageParam: "",
        parentId: "0",
        templateId: "10517999127617659",
        pagePath: "",
      },
      {
        iconResourceId: "",
        id: "10517999514656905",
        isSystemIcon: 0,
        name: "公司租户总览",
        orderNum: 1,
        pageId: "10500376977760480",
        pageInstanceName: null,
        pageParam: "",
        parentId: "10517999401132166",
        templateId: "10517999127617659",
        pagePath: "/overview/tenant/company",
      },
      {
        iconResourceId: "",
        id: "10518000363446412",
        isSystemIcon: 0,
        name: "账单",
        orderNum: 1,
        pageId: "0",
        pageInstanceName: null,
        pageParam: "",
        parentId: "0",
        templateId: "10517999127617659",
        pagePath: "",
      },
      {
        iconResourceId: "",
        id: "10518000402415759",
        isSystemIcon: 0,
        name: "公司账单",
        orderNum: 1,
        pageId: "10500376977760482",
        pageInstanceName: null,
        pageParam: "",
        parentId: "10518000363446412",
        templateId: "10517999127617659",
        pagePath: "/property/billForCompany",
      },
      {
        iconResourceId: "",
        id: "10532860068429829",
        isSystemIcon: 0,
        name: "告警管理",
        orderNum: 1,
        pageId: "10529073843806251",
        pageInstanceName: null,
        pageParam: "",
        parentId: "0",
        templateId: "10517999127617659",
        pagePath: "/alarm/alarmManagement/alarmForCompanyLessee",
      },
    ];
    return new Promise((resolve, reject) => {
      if (data.length == 0 || data == null) {
        resolve({
          code: null,
          success: false,
          msg: "当前用户尚无菜单。请联系创建该用户的用户！",
          data: null,
        });
        return;
      }
      for (let index = 0; index < data.length; index++) {
        if (!data[index].pagePath) {
          data[index].pagePath = "";
        }
        if (!data[index].pageParam) {
          data[index].pageParam = "";
        }
        data[index].pagePath = data[index].pagePath + data[index].pageParam;
      }
      data.sort((a, b) => {
        return a.orderNum - b.orderNum;
      });
      ctx.commit("SET_MENU_LIST", data);

      //删除带http的
      let comData = [];
      for (let index = 0; index < data.length; index++) {
        let pagePath = data[index].pagePath;
        data[index].iframe = false;
        let comItem = {};
        comItem = JSON.parse(JSON.stringify(data[index]));
        let path = comItem.pagePath;
        let url = comItem.pagePath;
        let params = {};
        if (pagePath.indexOf("?") > -1) {
          params = getRequest(pagePath);
          pagePath = pagePath.split("?")[0];
          path = pagePath;
        }
        comItem.path = path;
        comItem.url = url;
        comItem.params = params;
        let keepAlive = true;
        if (path === "/analysis/video") {
          keepAlive = false;
        }
        comItem.meta = {
          keepAlive: keepAlive,
        };
        comItem.component = pagePath.length == 0 ? "none" : pagePath;
        if (comItem.iframe == false) {
          comData.push(comItem);
        }
      }
      comData = Tree.creatMenuJson(comData, 0);

      //找出有没有第一级是直接页面的
      for (let i = 0; i < comData.length; i++) {
        if (comData[i].children.length == 0) {
          let item = JSON.parse(JSON.stringify(comData[i]));
          comData[i].children = [item];
          comData[i].path = "";
          comData[i].classA = true;
          comData[i].component = "Layout";
        }
      }

      data = Tree.creatMenuJson(data, 0);
      data = data.sort((a, b) => {
        return a.orderNum - b.orderNum;
      });
      let main = getMain(data[0]);
      if (main.path == "") {
        main.path = "/main";
      }
      ctx.commit("SET_MENU_DATA", data);
      ctx.commit("SET_MAIN", main);
      ctx.commit("SET_ROUTES", comData);
      resolve({
        success: true,
        data: data,
      });
    });
  },
  fedLogOut(ctx) {
    // ctx.commit('royter/SET_NULL')
    return new Promise((resolve, reject) => {
      api.login.logout().then((res) => {
        if (res) {
          ctx.commit("SIGNOUT");
          resolve(res);
        }
      });
    });
  },
};
const getters = {};

// 不要忘记把state, mutations等暴露出去。
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
